import React__default from 'react';

var Headline = function Headline(props) {
  var _props$as = props.as,
    as = _props$as === void 0 ? 'h4' : _props$as,
    children = props.children,
    className = props.className;
  var As = as;
  return /*#__PURE__*/React__default.createElement(As, {
    className: className
  }, children);
};

export { Headline };
//# sourceMappingURL=headline.esm.js.map
